module.exports = __webpack_public_path__ + "static/media/careplus-interreg-fwv.72633eee.jpg";